import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9pbogqftmtnfcfh0k2g';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫网',
    url: 'https://www.hanman-site.com/',
    description: '专业提供海量漫画免费韩漫，支持下拉式韩漫在线阅读，涵盖丰富的阅读漫画大全资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@hanman-site.com',
      availableLanguage: ['Chinese'],
    },
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 韩漫网站',
    description: '了解韩漫网站的品牌故事、口碑评价与联系方式。',
    url: 'https://www.hanman-site.com/about',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <Navbar />
      <main className="min-h-screen pt-20 pb-14">
        <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]} />
          </div>

          {/* Brand Intro */}
          <section className="mb-16">
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}>
                关于韩漫网
              </h1>
              <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                致力于为广大漫画爱好者提供最优质的<strong>漫画免费韩漫</strong>阅读体验
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20studio%20workspace%2C%20creative%20artists%20working%20on%20digital%20illustrations%2C%20warm%20modern%20office%2C%20drawing%20tablets%2C%20colorful%20manga%20art%20on%20walls%2C%20cozy%20atmosphere%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="韩漫网站 - 品牌故事"
                  className="w-full rounded-xl object-cover"
                  title="韩漫网站品牌故事"
                />
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4"
                  style={{ fontFamily: 'var(--font-heading)' }}>
                  我们的故事
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  韩漫网成立于2020年，是国内领先的<strong>韩漫在线阅读平台</strong>。我们的创始团队由一群热爱韩国漫画的资深从业者组成，深知国内读者对高质量<strong>漫画免费韩漫</strong>资源的迫切需求。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  经过多年的发展，韩漫网站已经成为国内最具影响力的<strong>韩漫网站</strong>之一。我们拥有超过<strong>10,000部</strong>优质韩漫资源，覆盖恋爱、奇幻、动作、悬疑等八大品类，每日为<strong>超过50万</strong>读者提供<strong>下拉式韩漫在线</strong>阅读服务。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的使命是让每一位漫画爱好者都能便捷地获取优质的<strong>阅读漫画大全</strong>资源，无需注册、无需付费，随时随地畅享高清流畅的韩漫阅读体验。我们相信，好的内容应该被更多人看到。
                </p>
              </div>
            </div>
          </section>

          {/* Values */}
          <section className="mb-16 py-12 bg-background-100 rounded-2xl px-6 md:px-10">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-10"
              style={{ fontFamily: 'var(--font-heading)' }}>
              我们的理念
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-shield-star-line', title: '品质保证', desc: '所有漫画经过精心筛选，确保画质高清、翻译准确，为读者提供最佳阅读体验' },
                { icon: 'ri-flashlight-line', title: '免费畅读', desc: '坚持免费开放原则，无需注册、无需付费，让每个人都能轻松享受韩漫的魅力' },
                { icon: 'ri-smartphone-line', title: '极致体验', desc: '专为手机和网页优化的下拉式阅读模式，流畅自然，沉浸式体验' },
                { icon: 'ri-refresh-line', title: '每日更新', desc: '热门连载与韩国同步更新，追更不等待，每天都有新鲜内容' },
              ].map((item) => (
                <div key={item.title} className="text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Testimonials */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-10"
              style={{ fontFamily: 'var(--font-heading)' }}>
              读者口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: '小猫咪爱看漫画',
                  avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%2C%20soft%20pastel%20colors%2C%20simple%20illustration%2C%20portrait&width=100&height=100&seq=avatar-01&orientation=squarish',
                  text: '用了这么多漫画网站，韩漫网站的阅读体验真的是最好的！下拉式阅读太舒服了，更新速度也很快，强烈推荐！',
                  rating: 5,
                },
                {
                  name: '追更小达人',
                  avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20boy%20avatar%2C%20simple%20illustration%2C%20warm%20colors%2C%20portrait&width=100&height=100&seq=avatar-02&orientation=squarish',
                  text: '每天必刷的漫画网站，资源非常丰富，各种类型的韩漫都有。最关键是免费不用注册，太良心了！',
                  rating: 5,
                },
                {
                  name: '深夜读书人',
                  avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20reading%2C%20soft%20illustration%2C%20gentle%20colors%2C%20portrait&width=100&height=100&seq=avatar-03&orientation=squarish',
                  text: '深夜睡不着的时候就会打开韩漫网站看漫画，分类很清晰，想找什么类型的一下就能找到，爱了爱了！',
                  rating: 5,
                },
              ].map((review) => (
                <div key={review.name} className="bg-background-100 rounded-xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={review.avatar} alt={review.name} className="w-10 h-10 rounded-full object-cover" />
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: review.rating }, (_, i) => (
                          <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-10"
              style={{ fontFamily: 'var(--font-heading)' }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@hanman-site.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h3>
                    <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-question-answer-line text-lg text-secondary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">意见反馈</h3>
                    <p className="text-sm text-foreground-500">我们非常重视每一位读者的意见，欢迎随时提出宝贵建议</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6">
                <h3 className="text-base font-semibold text-foreground-800 mb-4">发送消息</h3>
                <form
                  id="contact-form"
                  data-readdy-form="true"
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      const successEl = document.getElementById('contact-success');
                      if (successEl) successEl.style.display = 'block';
                      form.reset();
                      return;
                    }
                    const formData = new FormData(form);
                    formData.delete('website_alt');
                    try {
                      const res = await fetch(CONTACT_FORM_URL, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                      const serverMsg = parsed?.meta?.message || parsed?.message || '';
                      if (res.ok && parsed?.code === 'OK') {
                        const successEl = document.getElementById('contact-success');
                        const errorEl = document.getElementById('contact-error');
                        if (successEl) successEl.style.display = 'block';
                        if (errorEl) errorEl.style.display = 'none';
                        form.reset();
                      } else {
                        const errorEl = document.getElementById('contact-error');
                        if (errorEl) {
                          errorEl.style.display = 'block';
                          errorEl.textContent = serverMsg || '发送失败，请稍后重试';
                        }
                      }
                    } catch {
                      const errorEl = document.getElementById('contact-error');
                      if (errorEl) {
                        errorEl.style.display = 'block';
                        errorEl.textContent = '网络错误，请检查网络后重试';
                      }
                    }
                  }}
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">消息</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入您的消息（最多500字）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <div id="contact-success" style={{ display: 'none' }} className="text-sm text-secondary-500 text-center mt-2">
                    消息发送成功！我们会尽快回复您。
                  </div>
                  <div id="contact-error" style={{ display: 'none' }} className="text-sm text-red-500 text-center mt-2"></div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}